<ins-panel
	class="js-panel"
	[ngClass]="!headerVisible ? 'ins-panel--no-header' : ''"
	[toggler]="headerVisible ? 'header' : isOpen ? 'button' : 'header'"
	[open]="isOpen">
	<div
		class="panel-header"
		slot="header"
		[style.visibility]="headerVisible || !isOpen ? 'visible' : 'hidden'">
		<div class="panel-title">{{headerText}}</div>
		<div class="panel-validation">
			<skl-validation-area
				[hidden]="isOpen"
				[areaId]="panelId">
			</skl-validation-area>
		</div>
	</div>
	<div class="panel-content grid js-panel-body">
		<ng-content></ng-content>
	</div>
</ins-panel>
